/**
 * User:tendlich
 * layout of the ticket tab in the connection panel
 */
define(function (require) {
    "use strict";

    var template = require("connection-templates/ticketTab/TicketTabLayout.tmpl");
    var TicketSearchController = require("connection-controllers/ticketTab/TicketSearchController");
    var Notifier = require("ui/notifier/Notifier");
    var Loader = require("ui/loader/Loader");
    var TicketTabLayout = {};
    var LE = require("app");

    //be able to select the different regions and make them display a view
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketTabLayout = Marionette.Layout.extend({
            className: "ticket-tab",
            template: template,

            regions: {
                header:".header",
                searchInputRegion : ".search-input-region",
                ticketRegion : ".ticket-tab-region",
                supportRegion:".ticket-support-region",
                recentRegion : ".ticket-tab-region .recent-open-case-region",
                closedRegion : ".ticket-tab-region .closed-case-region",
                closedBugsRegion: ".ticket-tab-region .closed-with-bug-region",
                headerDetailedRegion: ".header-detailed-region"
            },

            ui: {
                ticketRegion : ".ticket-tab-region",
                header:".header",
                content: ".tickets-content-wrapper"
            },

            initialize: function (options) {
                options = options || {};
                this.mainContainerLayout = options.mainContainerLayout;
            },

            setLoader:function(){
                if(this.getIsRendered){
                    this._getLoader().render();
                }else{
                    this.listenTo(this,"render",function(){
                        this._getLoader().render();
                    });
                }
            },
            closeLoader: function () {
                this._getLoader().close();
            },
            _getLoader:function(){
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.$el,
                        zIndex:2
                    });
                }
                return this.loader;
            },
            hideRegions: function(){
                this._hideRegions();
            },
            showRegions: function(){
                this._showRegions();
            },
            _hideRegions:function(){
                this.ui.header.addClass("hide");
                this.ui.ticketRegion.addClass("hide");
            },
            _showRegions:function(){
                this.ui.header.removeClass("hide");
                this.ui.ticketRegion.removeClass("hide");
            }


        });
    });

    return TicketTabLayout;

});

